import { Button } from "@/components/ui/button";
import { MousePointer, Pencil, Square, Move, Type, Crop, ZoomIn, ZoomOut } from "lucide-react";

type Tool = "select" | "draw" | "rectangle" | "move" | "text" | "crop";

interface ToolBarProps {
  activeTool: Tool;
  onToolChange: (tool: Tool) => void;
  onZoom?: (direction: "in" | "out") => void;
  onReset: () => void;
}

export const ToolBar = ({ activeTool, onToolChange, onZoom }: ToolBarProps) => {
  return (
    <div className="flex flex-wrap gap-2 justify-center">
      <Button
        variant="outline"
        size="icon"
        onClick={() => onToolChange("select")}
        className={activeTool === "select" ? "bg-gray-100" : ""}
      >
        <MousePointer className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => onToolChange("draw")}
        className={activeTool === "draw" ? "bg-gray-100" : ""}
      >
        <Pencil className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => onToolChange("rectangle")}
        className={activeTool === "rectangle" ? "bg-gray-100" : ""}
      >
        <Square className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => onToolChange("text")}
        className={activeTool === "text" ? "bg-gray-100" : ""}
      >
        <Type className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => onToolChange("move")}
        className={activeTool === "move" ? "bg-gray-100" : ""}
      >
        <Move className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => onToolChange("crop")}
        className={activeTool === "crop" ? "bg-gray-100" : ""}
      >
        <Crop className="h-4 w-4" />
      </Button>
      {onZoom && (
        <>
          <Button
            variant="outline"
            size="icon"
            onClick={() => onZoom("in")}
            title="Zoom In"
          >
            <ZoomIn className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="icon"
            onClick={() => onZoom("out")}
            title="Zoom Out"
          >
            <ZoomOut className="h-4 w-4" />
          </Button>
        </>
      )}
    </div>
  );
};